import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import TeamsView from '../views/TeamsView.vue'
import ConferencesView from '../views/ConferencesView.vue'
import GameDetailView from '../views/GameDetailView.vue'
import ScoreboardView from '../views/ScoreboardView.vue'
import SettingsView from '../views/SettingsView.vue'

const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/teams',
      name: 'teams',
      component: TeamsView
    },
    {
      path: '/conferences',
      name: 'conferences',
      component: ConferencesView
    },
    {
      path: '/game/:id',
      name: 'game-detail',
      component: GameDetailView,
      props: true
    },
    {
      path: '/scoreboard',
      name: 'scoreboard',
      component: ScoreboardView
    },
    {
      path: '/settings',
      name: 'settings',
      component: SettingsView
    }
  ]
})

export default router